'use client'

import { Box, Container, Grid, Typography } from '@mui/material'
import React, { ReactElement } from 'react'
import Image from 'next/image'

export const HeroSection = (): ReactElement => {
	return (
		<Box
			sx={{
				py: 8,
				px: { xs: 2, md: 8, lg: 16 },
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: '100px'
			}}>
			<Container maxWidth='lg'>
				<Box
					sx={{
						width: '100%',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						gap: 7
					}}>
					<Grid container spacing={2} alignItems='center' className='justify-between w-full'>
						<Grid
							component='div'
							size={{
								xs: 12,
								md: 7.5
							}}>
							<Box className='flex flex-col gap-7'>
								<Typography variant='h5' className='font-bold text-2xl sm:text-[40px]'>
									Ingin menjangkau pasar lebih luas tapi bingung caranya?
								</Typography>

								<Typography variant='h5' className='font-medium text-base sm:text-xl'>
									Jangkau pelanggan di mana saja dengan toko online yang profesional
								</Typography>
							</Box>
						</Grid>
						<Grid
							component='div'
							size={{
								xs: 12,
								md: 4.5
							}}>
							<Box>
								<Image src={'assets/images/location-search-bro.svg'} alt='location-search' width={500} height={0} style={{ height: 'auto' }} />
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Container>
		</Box>
	)
}
